import { type ClassValue, clsx } from 'clsx';
import { params } from './constants';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function parseLocStore(pre: string): any {
  return localStorage.getItem(pre)
    ? JSON.parse(localStorage.getItem(pre)!)
    : null;
}

export function setLocal(key: string, val: any): void {
  localStorage.setItem(key, JSON.stringify(val));
}

export const setParam = ({ query, val }: { query: string; val: string }) => {
  const baseUrl = window.location.href.split('?')[0];
  const newUrl = `${baseUrl}?${params.toString()}`;
  params.set(query, val);
  window.history.pushState({}, '', newUrl);
};
